import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import l10n from "../../../l10n/localization";
import * as utils from "../../../utils/commodity";
import * as commodityActions from "../../../actions/commodity";

class SelectCommodities extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    componentDidMount() {
        this.props.dispatch(commodityActions.fetchCommodities(true));/*
        utils.notNullNorUndefined(this.props.item.fog.underwriter) &&
            this.props.dispatch(underwriterRateActions.fetchRates(this.props.item.fog.underwriter.id, true));
        utils.notNullNorUndefined(this.props.item.fog.client) &&
            this.props.dispatch(clientRateActions.fetchRates(this.props.item.fog.client.id, true));*/
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {

        return (
            <div className="form-group field">
                <label className="control-label" htmlFor="root_commodity">
                    {l10n.cargo.commodity}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_commodity"
                    value={this.props.formData}
                    options={utils.commodityToSelect(this.props.commodities)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        commodities: state.commodity.commodities,
        loading: state.commodity.loading,
    });
})(SelectCommodities);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectCommodities.js